import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Martín S.',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Lucía P.',
  location: 'Córdoba, Argentina'
}, {
  name: 'Diego M.',
  location: 'Rosario, Argentina'
}, {
  name: 'Carlos R.',
  location: 'CDMX, México'
}, {
  name: 'Ana G.',
  location: 'Guadalajara, México'
}, {
  name: 'Roberto F.',
  location: 'Monterrey, México'
}, {
  name: 'Laura C.',
  location: 'Bogotá, Colombia'
}, {
  name: 'Andrés V.',
  location: 'Medellín, Colombia'
}, {
  name: 'Fernando L.',
  location: 'Santiago, Chile'
}, {
  name: 'Valeria T.',
  location: 'Lima, Perú'
}, {
  name: 'Cecilia R.',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Diego S.',
  location: 'Quito, Ecuador'
}, {
  name: 'Camila V.',
  location: 'Caracas, Venezuela'
}, {
  name: 'Jorge M.',
  location: 'Guatemala'
}, {
  name: 'Karina R.',
  location: 'Asunción, Paraguay'
}, {
  name: 'Sebastián R.',
  location: 'La Paz, Bolivia'
}, {
  name: 'Martín H.',
  location: 'San José, Costa Rica'
}, {
  name: 'Lucía F.',
  location: 'Santo Domingo, Rep. Dominicana'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[260px] md:max-w-[280px]" data-id="element-221">
      <div className="bg-brand-card rounded-lg shadow-2xl border-2 border-brand-accent p-3 flex items-start gap-2.5 relative overflow-hidden" data-id="element-222">
        <div className="bg-brand-accent/20 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-223">
          <CheckCircle className="w-4 h-4 text-brand-accent" data-id="element-224" />
        </div>
        <div data-id="element-225">
          <p className="text-[10px] md:text-xs text-gray-200 font-medium leading-tight mb-0.5" data-id="element-226">
            <span className="font-black text-white" data-id="element-227">
              {currentPurchase.name}
            </span>{' '}
            de {currentPurchase.location} acaba de comprar el Kit Completo 🏐
          </p>
          <p className="text-[9px] text-brand-accent font-bold" data-id="element-228">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-229">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}